const setTimezone = (state, action) => {
  state.timezone = action.payload;
};

export default {
  setTimezone,
};
